import { BodyTypeRow } from "app/containers/BodyType/types";
import { TireTypeRow } from "app/containers/TireType/types";
import { ListPaginationMeta } from "utils/helpers/pagination";

export type RegistrationFilterValue = "ALL";

export enum NeedEngPlan {
  Yes = "Y",
  No = "N",
}

export interface RegistrationRow {
  keyID: number;
  manufacturerID: number;
  modelID: number;
  year: number;
  cabinType?: string;
  tireSize?: string;
  hangerType?: string;
  weight?: string;
  wealBase?: number;
  lowerRange?: number;
  upperRange?: number;
  axleLoad?: number;
  backAxleDistance?: number;
  remarks?: string;
  needEngPlan?: NeedEngPlan;
  sideWallTypeID?: number;
  structureType?: number;
}

export interface RegistrationForm {
  driverCabinType: string;
  tire: string;
  suspensionType: string;
  weight: string;
  axlesMeasure: string;
  lowerLimit: string;
  upperLimit: string;
  frontLoad: string;
  rearAxlesMeasure: string;
  notes: string;
  dhType: string;
  bodyType: string;
}

export type RegistrationFormFieldKind = "string" | "number";

export const REGISTRATION_FORM_FIELD_KINDS: Record<
  keyof RegistrationForm,
  RegistrationFormFieldKind
> = {
  driverCabinType: "string",
  tire: "string",
  suspensionType: "string",
  weight: "string",
  axlesMeasure: "number",
  lowerLimit: "number",
  upperLimit: "number",
  frontLoad: "number",
  rearAxlesMeasure: "number",
  notes: "string",
  dhType: "number",
  bodyType: "number",
};

export type RegistrationListMeta = ListPaginationMeta;

export type RegistrationFormDropDownKey = "tires" | "bodyTypes";

export interface RegistrationFormDropDownState<T> {
  items: T[];
  page: number;
  perPage: number;
  meta: RegistrationListMeta;
  loading: boolean;
}

export interface RegistrationFormDropDowns {
  tires: RegistrationFormDropDownState<TireTypeRow>;
  bodyTypes: RegistrationFormDropDownState<BodyTypeRow>;
}

export interface RegistrationListResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: RegistrationRow[];
  meta?: RegistrationListMeta;
}

export interface RegistrationUpdate {
  id: number;
  manufacturerID: number;
  modelID: number;
  year: number;
  cabinType: string;
  tireSize: string;
  hangerType: string;
  weight: string;
  wealBase: number;
  lowerRange: number;
  upperRange: number;
  axleLoad: number;
  backAxleDistance: number;
  remarks: string;
  needEngPlan: NeedEngPlan;
  sideWallTypeID: number;
  structureType: number;
}

export interface RegistrationState {
  loading: boolean;
  saving: boolean;
  list: RegistrationRow[];
  page: number;
  perPage: number;
  meta: RegistrationListMeta;
  error: string | null;
  driverCabinFilter: RegistrationFilterValue;
  axlesMeasureFilter: RegistrationFilterValue;
  frontLoadFilter: RegistrationFilterValue;
  rearAxlesMeasureFilter: RegistrationFilterValue;
  weightFilter: RegistrationFilterValue;
  tireFilter: RegistrationFilterValue;
  dhTypeFilter: RegistrationFilterValue;
  bodyTypeFilter: RegistrationFilterValue;
  isAddModalOpen: boolean;
  form: RegistrationForm;
  formDropDowns: RegistrationFormDropDowns;
}
